const LOCAL_DB = false; // !!!
const IS_DEBUG = false;
const ADMIN = false; // !!!

const debugGA = false;
const showDeliveryInfoBanner = false; // Info warning banner

interface IAppConfig {
  baseURL: string;
  debug: boolean;
  admin: boolean;
  debugGA: boolean;
  showDeliveryInfoBanner: boolean;
}

const appconfig: IAppConfig = {
  // baseURL: LOCAL_DB ? "http://localhost:7585/api" : "https://api.bojenjepobrojevima.rs/api",
  // baseURL: LOCAL_DB
  //   ? "http://localhost:7585/api"
  //   : "https://test.bojenjepobrojevima.rs/api",
  baseURL: LOCAL_DB
    ? "http://localhost:7585/api"
    : "https://bojenjepobrojevima.rs/api",
  debug: IS_DEBUG,
  admin: ADMIN,
  debugGA,
  showDeliveryInfoBanner,
};

export default appconfig;
